import { Directive, HostListener } from '@angular/core';

@Directive({
  selector: '[autoSelect]',
  standalone: false
})
export class AutoSelectDirective {
  @HostListener('focus', ['$event.target'])
  onFocus(target: EventTarget | null): void {
    const el = target as HTMLInputElement;
    if (el && typeof el.select === 'function') {
      el.select();
    }
  }
}
